import React from 'react'

import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import BlogList from '../Components/BlogList'

const Blog = () => {
  return (
    <>
      <Navbar />
      <BlogList />
      <Footer />
    </>
  )
}

export default Blog